import useStyles from 'isomorphic-style-loader/useStyles';
import type { RefObject } from 'react';

import s from './table-scroll-chrome.scss';

export interface TableScrollbarProxyProps {
  /**
   * Spacer whose width is written to match the body's canvas.
   */
  ghostRef: RefObject<HTMLDivElement>;
  /**
   * The proxy scroller itself, joined to the table's scroll-sync group.
   */
  scrollerRef: RefObject<HTMLDivElement>;
}

/**
 * The table's floating horizontal scrollbar, standing in for the body
 * scrollport's own so the bar stays in reach at the bottom of the viewport.
 */
export const TableScrollbarProxy = ({
  ghostRef,
  scrollerRef,
}: TableScrollbarProxyProps) => {
  useStyles(s);

  return (
    // Chrome makes a scroller focusable, which `aria-hidden` alone turns into an
    // `aria-hidden-focus` violation.
    <div
      ref={scrollerRef}
      aria-hidden
      className={s.scrollbarProxy}
      tabIndex={-1}
    >
      <div ref={ghostRef} className={s.scrollbarProxyGhost} />
    </div>
  );
};

/**
 * The gradient strips marking content clipped past either horizontal edge,
 * shown from the table root's scroll-position attributes.
 */
export const TableScrollScrims = () => {
  useStyles(s);

  return (
    <>
      <div aria-hidden className={s.scrimLeft} />

      <div aria-hidden className={s.scrimRight} />
    </>
  );
};
